import { API } from "./api";

export const addCampaign = (campaigns) => API.post(`/campaigns`, campaigns);

export const getAllCampaigns = (page = 1, limit = 10) => {
  return API.get(`/campaigns?page=${page}&limit=${limit}`);
};
export const getCampaignById = (campaignId) =>
  API.get(`campaigns/${campaignId}`);

export const updateCampaign = (campaignId, campaign) =>
  API.put(`/campaigns/${campaignId}`, campaign);

export const deleteCampaign = (campaignId) =>
  API.delete(`/campaigns/${campaignId}`);
